import * as React from 'react';
import { Paragraph2 } from '@cian/ui-kit';
import { EscrowRoundIcon } from '../Escrow/EscrowIcons';
import { Link } from '../Link';

import * as styles from './EscrowBlock.css';

interface IReliableBlockProps {
  text: string;
  onClick(event: React.MouseEvent<HTMLElement>): void;
}

export function EscrowBlock({ text, onClick }: IReliableBlockProps) {
  return (
    <div className={styles['container']}>
      <div className={styles['icon']}>
        <EscrowRoundIcon />
      </div>
      <div>
        <Paragraph2>{text}</Paragraph2>
        <Link url={'#escrow'} onClick={onClick}>
          Узнать больше
        </Link>
      </div>
    </div>
  );
}
